import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/internal/operators/tap';

import { AppProperties } from '@app/core/models';

function getRandomNumber() {
  return Math.floor(Math.random() * 1000000000000000);
}

@Injectable({
  providedIn: 'root'
})
export class PropertiesService {

  private properties: AppProperties = {};

  constructor(public http: HttpClient) { }

  fetch(): Observable<any> {
    const params =  { cachebust: getRandomNumber().toString() };
    return this.http.get('/properties/properties.json', { params }).pipe(
      tap(properties => this.properties = properties)
    );
  }

  get(property: string): string | boolean | undefined {
    return this.properties[property] || undefined;
  }

  isFeatureDisabled(featureName: string): boolean {
    let disabledFeatures = <string>this.get('disabledFeatures');
    if (!disabledFeatures) {
      return false;
    }
    disabledFeatures = disabledFeatures.replace(/\s/g, '');
    const disabledFeaturesArr = disabledFeatures.split(',');
    return disabledFeaturesArr.indexOf(featureName) !== -1 ? true : false;
  }
}
